export default __webpack_public_path__ + "static/media/MASCOT 4-06.87696da4.png";